import { Injectable } from '@angular/core';
import { IInstituation } from '../models/instituation';
import { ApiService } from '../../../shared/services/api/api.service';
import { IPagination } from '../../../shared/services/api/interface/pagination.interface';
import { Observable } from 'rxjs';

@Injectable({providedIn:'root'})
export class InstituationService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any[]>('instituation');
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`instituation/instituation-filter-list`, {event: event, filter: filter})
  }

  getById(id: number) {
    return this.apiService.get<IInstituation>(`instituation/${id}`);
  }

  create(data: any) {
    return this.apiService.post<any>('instituation/create', data);
  }

  update(data: any) {
    return this.apiService.patch<any>('instituation/update', data);
  }

  delete(id: number | string) {
    return this.apiService.delete(`instituation/delete/${id}`);
  }
}
